import { IEventRegistrationSurvey } from '@ViewModels';
import moment from 'moment-timezone';

export const getEventSearchLabel = (event: IEventRegistrationSurvey) => {
	const { startTime, timeZone, isAllDay } = event.eventInformation ?? {};
	if (!startTime) {
		return event.name;
	}
	if (isAllDay) {
		return `${event.name} - ${moment.tz(startTime, timeZone).format('MMM Do')} (All day)`;
	}
	return `${event.name} - ${moment(startTime).format('MMM Do hh:mm a')}`;
};
